import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import { units } from "../../../../types/units";

export const NavButton = styled(Button)`
  justify-content: start;
  padding: 16px 20px;
  border-radius: 0;
  background-color: ${(props) => (props.fullWidth ? props.theme.colors.navyBlue : "white")};
  color: ${(props) => (props.fullWidth ? props.theme.colors.lynxWhite : "black")};
  width: 100%;
  ${units({
    fontWeight: "normal",
    fontSize: "large",
    "&:hover": {
      color: "black",
      backgroundColor: "lightBlue",
    },
  })};
`;
